import { styled } from '@mui/material/styles';
export var StyledWrapper = styled('span')(function (_ref) {
  var required = _ref.required,
    theme = _ref.theme,
    hasValue = _ref.hasValue;
  return {
    '& input': {
      '&::placeholder': {
        textTransform: 'uppercase'
      }
    },
    '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: required && !hasValue ? theme.palette.secondary.main : theme.palette.grey.main
    }
  };
});